import React, {Component} from "react";
import './main_menu.scss';
import {isMobileOnly} from "react-device-detect";
import MainMenuContent from "./main_menu_content/main_menu_content";
import {RESTRICTED_EN_VALUES, RESTRICTED_IT_VALUES} from '../../config/restrictedValues';

// Graphics
import facebook from "../../assets/social_media_icons/facebook.svg";
import tiktok from "../../assets/social_media_icons/tiktok.svg";
import linkedin from "../../assets/social_media_icons/linkedin.svg";
import {ReactComponent as TwitterLogo} from "../../assets/social_media_icons/twitter.svg";
import youtube from "../../assets/social_media_icons/youtube.svg";
import instagram from "../../assets/social_media_icons/instagram.svg";
import app_store_badge from '../../assets/badges/app_store_badge.png';
import google_play_badge from '../../assets/badges/google-play-badge.png';
import clubhouse from "../../assets/social_media_icons/clubhouse.svg";
import wechat from "../../assets/social_media_icons/wechat.svg";

const SVG_ID = "#svg_id";

class MainMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHidden: true,
            activeMenuOption: null,
            buttonTitle: '',
            selector: null,
            selectedLanguageOption: this.props.selectedLanguageOption
        };
    }

    showContent(content, index) {
        this.setState({
            buttonTitle: index,
            activeMenuOption: content,
            isHidden: false,
            selector: index
        });
    }

    render() {
        let lang = this.props.language;
        let menuContent = this.props.menu;

        let getFirstLevelTitle = (value) => {
            for (let i = 0; i < menuContent.length; i++) {
                if (menuContent[i].title === value) menuContent.splice(i, 1);
            }
        };

        if (lang === 'en') {
            RESTRICTED_EN_VALUES.forEach(getFirstLevelTitle);
        } else if (lang === 'it') {
            RESTRICTED_IT_VALUES.forEach(getFirstLevelTitle);
        }

        return (
            <div id='main-menu' className={isMobileOnly ? "mobile" : "desktop"}>
                <div id="main-menu-content-container">
                    <div className="container-fluid container-adjusted">
                        <div className="row">
                            {/*sidebar*/}
                            <div id='sidebar' className="col-md-3">
                                <ul className="links-list">
                                    {menuContent.map((page, index) => (
                                        <li key={index} className="sidebar-li-item">
                                                <span
                                                    className={(this.state.selector === index ? 'active' : null) + ' menu-line'}>
                                                    <a href={page.relative} className="sidebar-menu-link">
                                                        <span onMouseEnter={() => this.showContent(page.action, index)}
                                                              className={!(index === 0 || index === 1 || index === 2 || index === 3 || index === menuContent.length - 1) ?
                                                                  'title' : ((index !== menuContent.length - 1) ? 'title-bold' : 'title-blue')}>
                                                            {page.title.toUpperCase()}
                                                        </span>
                                                        {console.log(page.title)}
                                                    </a>
                                                    {!isMobileOnly &&
                                                        <span className={this.state.selector === index && (menuContent[index].below && 'line')}/>
                                                    }
                                                </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            {/*content container*/}
                            {!isMobileOnly ? <div id="menu-content-container" className="col-md-8">
                                <div className="content-container">
                                    {!this.state.isHidden &&
                                    <MainMenuContent buttonTitle={this.state.buttonTitle} data={menuContent}/>}
                                </div>
                            </div> : null}

                        </div>
                    </div>

                    {/*footer*/}
                    <footer id="sticky-menu-footer">
                        <div className="container-fluid footer-content">
                            <div className="row">
                                {/*lingua*/}
                                <div className="container-fluid" id="lingua">
                                    <div className="row mx-auto">LINGUA</div>
                                </div>
                                <div className="container-fluid mb-5" id="language-selector-container">
                                    <div className="row mx-auto" id="language-selector">
                                        <div className={"col mr-3 lingua-it lang-" + this.props.language}
                                             onClick={() => this.props.changeLanguage('it')}>It
                                        </div>
                                        <div className={"col ml-3 mr-3 lingua-en lang-" + this.props.language}
                                             onClick={() => this.props.changeLanguage('en')}>En
                                        </div>
                                        <div className={"col ml-3 lingua-zh lang-" + this.props.language}
                                             onClick={() => this.props.changeLanguage('zh')}>Zh
                                        </div>
                                    </div>
                                </div>
                                {/*social*/}
                                <div className="col-lg-5">
                                    <div
                                        className={!isMobileOnly ? 'container-fluid social-container' : 'container-fluid'}>
                                        <div className="row text-center">
                                            {/*social left*/}
                                            <div className="col-12 col-sm-6 social-list-part pr-md-0">
                                                <div className="float-sm-right">
                                                    <a href="https://www.facebook.com/uni.luiss" className="social-icon facebook">
                                                        <svg className="social-icon facebook">
                                                            <use xlinkHref={`${facebook}${SVG_ID}`}/>
                                                        </svg>
                                                    </a>
                                                    <a href=" https://vm.tiktok.com/4JAtqe/" className="social-icon messenger">
                                                        <svg className="social-icon messenger">
                                                            <use xlinkHref={`${tiktok}${SVG_ID}`}/>
                                                        </svg>
                                                    </a>
                                                    <a href="https://it.linkedin.com/school/luiss-guido-carli-university/" className="social-icon whatsapp">
                                                        <svg className="social-icon whatsapp">
                                                            <use xlinkHref={`${linkedin}${SVG_ID}`}/>
                                                        </svg>
                                                    </a>
                                                    <a href="https://weixin.qq.com/r/rRxQSBrECEd3rV4r90m-" aria-label="WeChat">
                                                        <svg className="social-icon wechat">
                                                            <use xlinkHref={`${wechat}${SVG_ID}`}/>
                                                        </svg>
                                                    </a>
                                                </div>
                                            </div>
                                            {/*social right*/}
                                            <div className="col-12 col-sm-6 social-list-part pl-md-0">
                                                <div className="float-sm-left">
                                                    <a href="https://twitter.com/uniLUISS" className="social-icon twitter">
                                                        <TwitterLogo/>
                                                        {/* <svg className="social-icon twitter">
                                                            <use xlinkHref={`${twitter}${SVG_ID}`}/>
                                                        </svg> */}
                                                    </a>
                                                    <a href="https://www.youtube.com/user/LUISSGuidoCarli" className="social-icon youtube">
                                                        <svg className="social-icon youtube">
                                                            <use xlinkHref={`${youtube}${SVG_ID}`}/>
                                                        </svg>
                                                    </a>
                                                    <a href="https://www.instagram.com/uniluiss/" className="siconocial- instagram">
                                                        <svg className="social-icon instagram">
                                                            <use xlinkHref={`${instagram}${SVG_ID}`}/>
                                                        </svg>
                                                    </a>
                                                    <a href="https://www.joinclubhouse.com/club/luiss-university" className="social-icon clubhouse" aria-label="Clubhouse">
                                                        <svg className="social-icon clubhouse">
                                                            <use xlinkHref={`${clubhouse}${SVG_ID}`}/>
                                                        </svg>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*text*/}
                                <div className="col-lg-7">

                                    <div className="container-fluid">
                                        <div className="row">
                                            <div
                                                className={!isMobileOnly ? 'col-sm-7 footer-text text-right' : 'col-sm-7 footer-text-mob'}>
                                                <p>Scarica l’app Luiss, ti aiuterà nell’esperienza didattica e
                                                    formativa.</p>
                                            </div>
                                            {/*badges*/}
                                            <div className="col-sm-5 text-center">
                                                <ul className="store-badges float-lg-right">
                                                    <li className="app_store_badge mr-2">
                                                        <a href="https://apps.apple.com/it/app/luiss/id1039424016">
                                                            <img className={!isMobileOnly ? 'store-icon' : 'store-icon-mob'}
                                                                 src={app_store_badge}
                                                                 alt="Download-on-the-App-Store"/>
                                                        </a>
                                                    </li>
                                                    <li className="google_play_badge ml-2">
                                                        <a href="https://play.google.com/store/apps/details?id=it.luiss.tsc">
                                                            <img className={!isMobileOnly ? 'store-icon' : 'store-icon-mob'}
                                                                 src={google_play_badge}
                                                                 alt="Google-Play"/>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </footer>
                </div>
            </div>
        );
    }
}

export default MainMenu;
